import React, { useEffect, useState } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Modal, ModalBody } from 'reactstrap';
import BreadCrumb from '../Common/BreadCrumb';
import { MaterialReactTable } from 'material-react-table';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from '../Utils/Loader';
import { ToastContainer, toast } from 'react-toastify';
import { setEditSuccessMessage, setSuccessMessage } from '../../slices/toastMessage/action';
import { MenuItem } from "@mui/material";
import CommonModal from "../Utils/CommonModal";
import { QuotaForm } from './QuotaForm';
import { deleteQuota } from '../../slices/QuotaManagement/DeleteQuota/thunk';
import { fetchAllOffers } from '../../slices/offer/thunk';
import { handleExportData } from '../Utils/ExportToCsv';
import { getQuotaByEvent } from '../../slices/QuotaManagement/GetQuota/thunk';
import { RatingForm } from './RatingForm';
import { getAllRatingGroup } from '../../slices/RatingGroup/thunk';
import { getRatingGroupAll } from '../../slices/RatingGroup/GetRatingGroup/thunk';
import { deleteRatingGroup } from '../../slices/RatingGroup/DeleteRatingGroup/thunk';
import { useColumnSettings } from '../Utils/useColumnSettings';
import { hasPermission } from '../Utils/UtilityFunctions';

function RatingGroup() {
    const [loading, setLoading] = useState(false);
    const [messageForPopUp, setMessageForPopUp] = useState('');
    const [eventType, setEventType] = useState("")
    const [selectedQuota, setSelectedQuota] = useState(null);
    const [isEditMode, setIsEditMode] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalForBulkDelete, setModalForBulkDelete] = useState(false)
    const [selectedRowsForBulkDelete, setSelectedRowsForBulkDelete] = useState()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const showSuccessMessage = useSelector((state) => state.SuccessToast.showSuccessMessage);
    const showEditSuccessMessage = useSelector((state) => state.SuccessToast.showEditSuccessMessage);
    const uom = useSelector((state) => state.Uom.uom);
    const rawPermissions = useSelector(
        (state) => state.permissions.permissionsMap
    );

    const permissionsMap = new Map(
        rawPermissions.map(([key, value]) => [key, new Set(value)])
    );
    const [modalOpen, setModalOpen] = useState(false);
    const toggleModals = () => {
        setModalOpen(prev => !prev);
    };


    const ratingPermission = hasPermission(permissionsMap, "charging", "ratinggroup")
    const viewPermission=hasPermission(permissionsMap, "miscellaneous", "view")
    const columns = [
        {
            accessorKey: 'serviceContextID',
            header: 'Service Context ID',
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value === "" || value === "" ? "-" : value;
            },
        },
        {
            accessorKey: 'serviceIdentifier',
            header: 'Service Identifier',
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value === "0" || value === 0 ? "-" : value;
            },
        },
        {
            accessorKey: 'ratingGroup',
            header: 'Rating Group',
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value === "0" || value === 0 ? "-" : value;
            },
        },
        {
            accessorKey: 'eventType',
            header: 'Event Type',
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value === "" || !value ? "-" : value;
            },
        },
        {
            accessorKey: 'avpName',
            header: 'AVP Name',
            Cell: ({ cell }) => {
                const value = cell.getValue();
                return value === "" || value === "" ? "-" : value;
            },
        },
    ];
    useEffect(() => {
        dispatch(getAllRatingGroup(setLoading))
        dispatch(fetchAllOffers(setLoading));
    }, [dispatch]);

    const offers = useSelector((state) => state.Offer?.offer || []);
    const quotaByEventType = useSelector((state) => state.GetRatingGroupByEvent.RatingGroupAll);
    const rating = useSelector((state) => state.GetAllRatingGroup.ratingGroup)

    useEffect(() => {
        if (isEditMode && quotaByEventType) {
            setSelectedQuota(prev => ({ ...prev, ...quotaByEventType }));
        }
    }, [quotaByEventType]);
    const extractedData = Array.from(
        new Map(
            offers.flatMap(offer =>
                offer.usageRatePlan?.map(({ eventType, uomName }) => ({
                    eventType,
                    uom: uomName
                })) || []
            ).map(obj => [`${obj.eventType}-${obj.uom}`, obj])
        ).values()
    );
    useEffect(() => {
        if (showSuccessMessage) {
            toast.success(`Rating Group Created Successfully`);
            dispatch(setSuccessMessage(false));
        }
        if (showEditSuccessMessage) {
            toast.success(`Rating Group Updated Successfully`);
            dispatch(setEditSuccessMessage(false));
        }
    }, [showSuccessMessage, showEditSuccessMessage, dispatch]);

    const toggleModal = (id, singleOrMulti) => {
        if (singleOrMulti === "single") {
            setEventType(id);
            setModal(!modal);
        }
        document.body.style.overflow = 'auto';
    };
    const {
        settingsModalOpen,
        viewColumns,
        toggleSettingsModal,
        SettingsSidebar,
        CustomViewModal
    } = useColumnSettings('quota', columns);
    return (
        <React.Fragment>
            <div id='csms' className='page-content bg-white'>
                <Container fluid>
                    <BreadCrumb title="Rating Group" pageTitle="Charging" />
                    <ToastContainer position='top-center' />
                    <Row>
                        <Col >
                            <div className="listingjs-table" id="customerList">

                                <CardBody>
                                    <Row className="  table-responsive">
                                        {loading && (<Loader />)}
                                        {uom ?
                                            <>
                                                <MaterialReactTable
                                                    icons={{
                                                        DragHandleIcon: () => <i className="ri-drag-move-fill" />,
                                                    }}

                                                    positionToolbarAlertBanner='none'
                                                    renderTopToolbarCustomActions={({ table }) => (
                                                        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100 mt-n1">
                                                            <h5 className="rv-page-title">Rating Group List</h5>

                                                            <div className="d-flex align-items-center">
                                                                <div className="d-flex ">
                                                                    {ratingPermission && ratingPermission?.has("export") &&
                                                                        <Button
                                                                            color="secondary"
                                                                            className="btn-label rv-secondary-btn rounded-1 px-1 ps-4 py-1 w-100 me-2 w-md-auto text-nowrap"
                                                                            onClick={() => { handleExportData(rating) }}
                                                                        >
                                                                            <i className="ri-download-line label-icon secondary-label-icon align-middle fs-16 me-2"></i>
                                                                            <span className="px-2 ps-3 ms-2 me-1">Export</span>
                                                                        </Button>}
                                                                    {ratingPermission && ratingPermission?.has("create") &&
                                                                        <Button
                                                                            color="secondary"
                                                                            className="btn-label rv-primary-btn me-2 rounded-1 px-1 ps-4 py-1 w-100 w-md-auto text-nowrap"
                                                                            onClick={() => {
                                                                                setModalOpen(true);
                                                                                setIsEditMode(false);
                                                                            }}
                                                                        >
                                                                            <i className="ri-add-fill label-icon align-middle fs-16 me-1"></i>
                                                                            <span className="ps-2 ms-2 me-1">Add Rating Group</span>
                                                                        </Button>
                                                                    }

                                                                </div>
                                                                {viewPermission && viewPermission?.has("view") &&
                                                                <div color="secondary" className="btn-icon cursor-img" onClick={toggleSettingsModal}>
                                                                    <i className="ri-settings-2-line fs-4"></i>
                                                                </div>}
                                                            </div>
                                                        </div>
                                                    )}
                                                    // renderTopToolbarCustomActions={({ table }) => (
                                                    //     <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between w-100">
                                                    //         <div className="d-flex flex-column flex-md-row">
                                                    //             <Button color="secondary" className="btn-label me-2 mb-2 mb-md-0" onClick={() => { handleExportData(rating) }}>
                                                    //                 <i className="ri-upload-line label-icon align-middle fs-16 me-2"></i> Export Data
                                                    //             </Button>
                                                    //             {uomPermission && uomPermission.permissionList.includes('create') &&
                                                    //                 <Button
                                                    //                     color="secondary"
                                                    //                     className="btn-label me-2 mb-2 mb-md-0"
                                                    //                     onClick={() => {
                                                    //                         setModalOpen(true);
                                                    //                         setIsEditMode(false);
                                                    //                     }}
                                                    //                 >
                                                    //                     <i className="ri-add-fill label-icon align-middle fs-16 me-2"></i> Add Rating Group
                                                    //                 </Button>}
                                                    //         </div>
                                                    //     </div>
                                                    // )}
                                                    initialState={{
                                                        columnOrder: [
                                                            'mrt-row-actions',
                                                            'Name',
                                                            'Value Type'
                                                        ]
                                                    }}
                                                    columns={columns}
                                                    data={rating}
                                                    enableColumnActions={true}
                                                    enableRowActions={true}
                                                    displayColumnDefOptions={{
                                                        'mrt-row-actions': {
                                                            header: '',
                                                            enableHiding: false,
                                                        },
                                                    }}
                                                    muiTableContainerProps={{
                                                        sx: {
                                                            border: '1px solid #e9ebec',
                                                        }
                                                    }}
                                                    defaultColumn={{
                                                        minSize: 1,
                                                        maxSize: 9001,
                                                        muiTableBodyCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        },
                                                        muiTableHeadCellProps: {
                                                            sx: {
                                                                fontFamily: "Inter,sans-serif"
                                                            }
                                                        }
                                                    }}
                                                    layoutMode='grid'
                                                    renderRowActionMenuItems={({ closeMenu, row }) => [
                                                        ratingPermission && ratingPermission?.has("update") ?
                                                            <MenuItem className='row-options' key={`${row.index}.2`} onClick={() => {
                                                                setIsEditMode(true);
                                                                setSelectedQuota(row.original);
                                                                setModalOpen(true);
                                                                dispatch(getRatingGroupAll(setLoading, row.original.ratingGroup, row.original.serviceIdentifier, row.original.serviceContextID));
                                                                closeMenu();
                                                            }}><i className="bx bxs-edit me-2" /> Edit</MenuItem> : null,
                                                        ratingPermission && ratingPermission?.has("delete") ?
                                                            <MenuItem className='row-options'
                                                                key="delete"
                                                                onClick={() => {
                                                                    setMessageForPopUp(`Are you sure you want to delete "${row.original.serviceIdentifier}"?`)
                                                                    toggleModal(row, "single");
                                                                    closeMenu();
                                                                }}
                                                            >
                                                                <i className="ri ri-delete-bin-5-line me-2" /> Delete
                                                            </MenuItem> : null,
                                                    ]}
                                                    enableDensityToggle={false}
                                                />
                                            </>
                                            : null
                                        }
                                    </Row>
                                </CardBody>

                            </div>
                        </Col>
                        {CustomViewModal()}
                    </Row>
                </Container>
                <CommonModal modalHeader={'Delete Rating Group'}  messageForPopUp={messageForPopUp} toggle={() => { if (modal) { toggleModal(eventType, "single") } else { toggleModal(selectedRowsForBulkDelete, "multi") } }
                } open={modalForBulkDelete ? modalForBulkDelete : modal} buttonText={"Yes, Delete It"} modalAction={() => {
                    if (modal) {
                        dispatch(deleteRatingGroup(eventType.original.ratingGroup,eventType.original.serviceIdentifier, eventType.original.serviceContextID, setLoading, navigate));
                        toggleModal(eventType, "single");
                    }
                }} />
                <Modal isOpen={modalOpen} toggle={toggleModals} centered size="md" className="custom-modal">
                    <button type="button" className="close-button-currency mt-n1" onClick={toggleModals}>
                        &times;
                    </button>
                    <h5 className="text-center w-100  fw-semibold py-3 ">
                        {isEditMode ? "Edit Rating Group" : "Add Rating Group"}
                    </h5>
                    <ModalBody>
                        <RatingForm extractedData={extractedData} toggleModals={toggleModals} setModalOpen={setModalOpen} initialData={isEditMode ? selectedQuota : null} isEditMode={isEditMode} />
                    </ModalBody>
                </Modal>
            </div>
        </React.Fragment>
    );
}

export default RatingGroup;
